var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMineBirthday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_mine_birthday") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E2A\\u4EBA\\u4E2D\\u5FC3-\\u6211\\u7684\\u4FE1\\u606F",
    transform: "translate(-1164, -446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_mine_birthday",
    transform: "translate(1162, 443)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(2, 3)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27999414,0 L6.35999414,0 L6.35999414,1.09311654 L5.27999414,1.09311654 L5.27999414,0 L5.27999414,0 Z M8.46,0 L9.54,0 L9.54,1.09311654 L8.46,1.09311654 L8.46,0 L8.46,0 Z M11.6400059,0 L12.7200059,0 L12.7200059,1.09311654 L11.6400059,1.09311654 L11.6400059,0 L11.6400059,0 Z M5.27999414,2.12551032 L6.35999414,2.12551032 L6.35999414,5.89069546 L5.27999414,5.89069546 L5.27999414,2.12551032 Z M8.46,2.12551032 L9.54,2.12551032 L9.54,5.89069546 L8.46,5.89069546 L8.46,2.12551032 L8.46,2.12551032 Z M11.6400059,2.12551032 L12.7200059,2.12551032 L12.7200059,5.89069546 L11.6400059,5.89069546 L11.6400059,2.12551032 L11.6400059,2.12551032 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8999941,13.9068835 L15.8999941,6.98381201 C15.8896273,6.08262661 15.170366,5.35462989 14.2799941,5.34413719 L3.65999414,5.34413719 C2.76962226,5.35462989 2.05036093,6.08262661 2.03999414,6.98381201 L2.03999414,13.9068835 L0,13.9068835 L0,15 L18,15 L18,13.9068835 L15.8999941,13.9068835 L15.8999941,13.9068835 Z M3.18000586,13.9068835 L3.18000586,6.98381201 C3.18000586,6.86234868 3.24,6.68016259 3.36000586,6.61943983 C3.47999414,6.4979765 3.6,6.43725373 3.72000586,6.43725373 L14.3400059,6.43725373 C14.4599941,6.43725373 14.6399941,6.4979765 14.7000059,6.61943983 C14.8199941,6.74088536 14.8800059,6.86234868 14.8800059,6.98381201 L14.8800059,13.9068835 L3.18000586,13.9068835 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMineBirthday);
export default __webpack_public_path__ + "static/media/icon_mine_birthday.svg";
export { ForwardRef as ReactComponent };